// frontend/src/components/Common/Toast.jsx

import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiXCircle, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';
import './Toast.css';

const Toast = ({ 
  id,
  message, 
  type = 'success', 
  duration = 3000,
  requireConfirm = false,
  onConfirm,
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Only auto-dismiss if not requiring confirmation
    if (!requireConfirm && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onClose(id), 300); // Wait for animation
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, requireConfirm, onClose, id]);

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    setIsVisible(false);
    setTimeout(() => onClose(id), 300);
  };

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose(id), 300);
  };

  const icons = {
    success: <FiCheckCircle size={20} />,
    error: <FiXCircle size={20} />,
    warning: <FiAlertCircle size={20} />,
    info: <FiInfo size={20} />
  };

  return (
    <div className={`toast toast-${type} ${isVisible ? '' : 'toast-hiding'} ${requireConfirm ? 'toast-confirm' : ''}`}>
      <div className="toast-icon">
        {icons[type]}
      </div>
      <div className="toast-content">
        <div className="toast-message">{message}</div>
        
        {/* Show Confirm/Cancel buttons if confirmation required */}
        {requireConfirm && (
          <div className="toast-actions">
            <button onClick={handleClose} className="toast-cancel-btn">
              Cancel
            </button>
            <button onClick={handleConfirm} className="toast-confirm-btn">
              Confirm
            </button>
          </div>
        )}
      </div>
      
      {/* Only show X close button if not requiring confirmation */}
      {!requireConfirm && (
        <button className="toast-close" onClick={handleClose}>
          <FiX size={18} />
        </button>
      )}
      
      {/* Progress bar only for auto-dismiss */}
      {!requireConfirm && duration > 0 && (
        <div className="toast-progress">
          <div 
            className="toast-progress-bar"
            style={{ animationDuration: `${duration}ms` }}
          />
        </div>
      )}
    </div>
  );
};

export default Toast;